$('.js-back').on('click', () => {
  window.history.back();
});